import { EventEmitter, Injectable, Output } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class SessionService {
  // Set agent Status
  @Output() setOffline: EventEmitter<any> = new EventEmitter();
  // Change company.
  @Output() changeCompany: EventEmitter<any> = new EventEmitter();

  constructor() { }
}
